/**
 * 反馈内容
 * @description 用于提交反馈
 */
export interface Feedback {
    /**
     * @description 反馈模块类型
     */
    type: string;
    /**
     * @description 反馈内容
     */
    comment: string;
    /**
     * @description 任务ID
     */
    taskId?: string;
}

export const FeedbackService = Symbol('FeedbackService');

/**
 * 反馈服务
 * @description 用于提交反馈
 */
export interface FeedbackService {
    /**
     * @description 提交反馈
     * @param feedback 反馈
     */
    save(feedback: Feedback): Promise<void>;
}
